import { Font } from '@react-pdf/renderer';

// Self-hosted EB Garamond, shared by the CAP proposal PDF (same family the
// transcript and syllabus PDFs register). Import this module once per PDF
// document to register the family before rendering.
let registered = false;

export function registerPdfFonts(): void {
  if (registered) return;
  Font.register({
    family: 'EB Garamond',
    fonts: [
      { src: '/fonts/EBGaramond-Regular.ttf' },
      { src: '/fonts/EBGaramond-Bold.ttf', fontWeight: 700 },
      { src: '/fonts/EBGaramond-Italic.ttf', fontStyle: 'italic' },
      { src: '/fonts/EBGaramond-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    ],
  });
  registered = true;
}
